/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Target_Email_PhInputs */

const en_fw_notify_target_email_ph = /** @type {(inputs: Fw_Notify_Target_Email_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const id_fw_notify_target_email_ph = /** @type {(inputs: Fw_Notify_Target_Email_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kamu@contoh.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Fw_Notify_Target_Email_PhInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_target_email_ph = /** @type {((inputs?: Fw_Notify_Target_Email_PhInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Target_Email_PhInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_target_email_ph(inputs)
	return en_fw_notify_target_email_ph(inputs)
});